<template>
    <section>
      <div class="mdl-grid center-items">
        <div class="mdl-cell mdl-cell--12-col center-items">
          <h4>Join Existing League</h4>
          <form id="join-league-form" v-on:submit.prevent="joinLeague">
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label has-placeholder">
             <select class="mdl-textfield__input form-control" v-model="leagueInfo.leagueUID" :required="true">
                <option v-for="l of leagues" v-if="l.status=='pre'" v-bind:value="l['.key']">{{ l.leagueName }}</option>
              </select>
              <label class="mdl-textfield__label" for="viewStatsSelect">Choose League</label>
            </div>
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label has-placeholder">
              <input class="mdl-textfield__input" type="text" id="passcodeJoin" autocomplete="off" v-model="leagueInfo.leagueSecret" required>
              <label class="mdl-textfield__label" for="passcodeJoin">League Secret</label>
            </div>
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label has-placeholder">
              <input class="mdl-textfield__input" type="text" id="joinTeamName" autocomplete="off" v-model="leagueInfo.teamName" required>
              <label class="mdl-textfield__label" for="joinTeamName">New Team Name</label>
            </div>
            <div>
              <button id="submitJoin" type="submit" class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect">
                Join League
              </button>
            </div> 
          </form>     
        </div>
      </div>  
    </section>
</template>

<script>
import { db } from '../db'
import firebase from "firebase";
import navigation from "@/components/NavBar.vue";

export default {
  data() {
    return {
      leagues: [],
      user: null,
      leagueInfo: {
        leagueUID: "",
        leagueName: "",
        leagueSecret: "",
        teamName: ""
      },
    }
  },
  components: {
    navigation,
  },
  firebase: {
    leagues: db.ref('leagues')
  },
  created() {
    firebase.auth().onAuthStateChanged(async (user) => {
        if (user) {
            this.user = user;
        }
    });
  },
  methods: {
    joinLeague: async function() {
        console.log("Want to join league "+this.leagueSelectedKey+" with passcode "+this.leagueSecretInput+" with team name "+this.newTeamName)

        this.leagues.forEach(async (l)=> {
            if (l['.key'] == this.leagueInfo.leagueUID && l['status']=='pre'){
                // console.log("Attempting to join: "+l['.key'])
                if (l["leaguePasswordCode"]==this.leagueInfo.leagueSecret){
                    // console.log("Yay, successfully joined league")
                    firebase.database().ref('/users/'+this.user.uid+'/leagues/').push(this.leagueInfo)
                    location.reload();
                } else {
                    alert("Error joining league")
                }
                
            }
        })
    }
  }
}

</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/JoinLeague.vue